export const toIdSelectionEntries = (ids: readonly string[]): { id: string }[] =>
  ids.filter(Boolean).map((id) => ({ id }));

export const idsFromSelection = (entries: readonly { id: string }[]): string[] =>
  entries.map(({ id }) => id).filter(Boolean);
